export default {
  portfolio: {
    title: 'Portfolio',
    contents: {
      design: {
        title: 'DESIGN',
        description: 'We can create the graphic identity for your company. We also design advertising material (posters, brochures and others). Our designers has some awesome ideas!'
      },
      software: {
        title: 'SOFTWARE',
        description: 'We create software for an adequate management of your company\'s operations.'
      },
      app: {
        title: 'APP',
        description: 'We develop mobile applications that provide practical solutions to your client\'s needs.'
      },
      web: {
        title: 'WEB',
        description: 'We can create attractive, fast and safe websites. We can give you our advise on what\'s options do you have, to help you make the best decision.'
      }
    },
    textHeader: 'WHAT WE DO',
    textFooter: 'We specialize in web development, apps development, graphic design and in bailing out our clients from disasters',
    modal: {
      tecnology: 'TECHNOLOGIES: '
    }
  }
}



// WEBPACK FOOTER //
// ./src/i18n/en/portfolio.js